import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  CustomTextField,
  CustomTitle,
  CustomText,
  CustomButton,
  CustomButton1,
  CustomCheckbox,
} from "../../components/Custom";
import MenuItem from "@mui/material/MenuItem";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import Service from "../../services";
import { useFormik } from "formik";

// import validationSchema from "./validation";
// import { CropContext } from "../../context";
// import Service from "../../services";

const CreateUsers = (props) => {
  // const appdata = useContext(CropContext);
  // const [logisticsData, setLogisticsData] = appdata[11];
  // const [locationPlanningData, setLocationPlanningData] = appdata[20];

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [columnsRequired, setColumnsRequired] = useState([]);
  const [requestFile, setRequestFile] = useState();

  //File upload
  const [fileUploadSuccess, setFileUploadSuccess] = useState(false);
  const [fileUploadFail, setFileUploadFail] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [invalidRows, setInvalidRows] = useState([]);

  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      staff_id: "",
      hub: "",
      level: "",
    },
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 4));

      saveFormData(values);
    },
  });
  //HANDLE FORM SUBMIT

  async function saveFormData(values) {
    let payload = {
      staff_id: values.staff_id,
      hub: values.hub,
      level: values.level,
    };
    setErrorMsg(false);
    setSubmitted(false);
    setLoading(true);
    console.log("handlesubmit");
    const response = await Service.createUser(payload);
    console.log(response);
    // const responseMessage = response.message;
    if (response.status === 200 || response.status === 201) {
      setLoading(false);
      setSubmitted(true);
      window.setTimeout(function () {
        navigate(0);
      }, 2000);
    } else {
      setLoading(false);
      setErrorMsg(true);
      window.setTimeout(function () {
        setErrorMsg(false);
      }, 6000);
    }
    // console.log(responseData);
  }

  //HANDLE FILE IMPORT
  const changeHandler = (e) => {
    let fileUploaded = document.querySelector(`#${e.target.id}`);
    console.log(fileUploaded);
    let fileName = fileUploaded.value;
    let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
    if (ext === "csv") {
      setRequestFile(e.target.files[0]);
    } else {
      alert("Invalid file format. Upload a .csv file");
    }
  };

  //Bulk Request File submit
  async function handleFileSubmit() {
    setFileUploading(true);

    setFileUploadSuccess(false);
    setFileUploadFail(false);
    setInvalidRows(false);
    const formData = new FormData();
    formData.append("file", requestFile);

    let payload = formData;
    // console.log(payload);

    const response = await Service.bulkUsers(payload);
    console.log(response);
    if (response.status === 200 || response.status === 201) {
      setFileUploading(false);
      setFileUploadSuccess(true);
    } else if (response.status === 403) {
      let invalid = [];
      response.data.data.map((row, index) => {
        if (row.status === false) {
          console.log(index + 1);
          invalid.push(index + 1);
          setInvalidRows(invalid);
        }
      });
      console.log(invalid);
      console.log(response.data);
      setFileUploading(false);
      setFileUploadSuccess(true);
      // setInvalidRows(true);
    } else {
      setFileUploading(false);
      setFileUploadFail(true);
    }
  }

  return (
    <div className="container">
      <Grid container spacing={0}>
        <Grid item xs={12} md={12}>
          <form>
            <Box>
              {/* <div>{displayForecastGroup}</div> */}
              <CustomTitle sx={{ fontSize: "20px", mb: 2 }}>
                Create User
              </CustomTitle>
              <CustomText sx={{ fontSize: "20px", mb: 2 }}>
                Please provide details of the new user below
              </CustomText>
              <Box
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  border: 1,
                  borderRadius: 1,
                  p: 3,
                  mb: 2,
                }}
              >
                <br />
                <CustomText>Staff Id</CustomText>
                <CustomTextField
                  type="text"
                  name="staff_id"
                  id="staff_id"
                  value={formik.values.staff_id}
                  onChange={formik.handleChange}
                  placeholder="Enter Staff Id"
                  sx={{ mb: 2 }}
                  fullWidth
                />
                <br />

                <CustomText>Hub</CustomText>
                <CustomTextField
                  type="text"
                  name="hub"
                  id="hub"
                  value={formik.values.hub}
                  onChange={formik.handleChange}
                  placeholder="Enter Hub"
                  sx={{ mb: 2 }}
                  fullWidth
                />
                <br />

                <CustomText>Level</CustomText>
                <CustomTextField
                  name="level"
                  id="level"
                  value={formik.values.level}
                  onChange={formik.handleChange}
                  label="Select Level"
                  select
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value={"0"}>0</MenuItem>
                  <MenuItem value={"1"}>1</MenuItem>
                  <MenuItem value={"2"}>2</MenuItem>
                  <MenuItem value={"3"}>3</MenuItem>
                </CustomTextField>

                <br />
                <Box
                  sx={{
                    textAlign: "center",
                  }}
                >
                  <CustomButton
                    // onClick={(e) => saveFormData()}
                    onClick={formik.handleSubmit}
                    variant="contained"
                    disabled={loading}
                    sx={{
                      alignItems: "center",
                      py: 2,
                      px: 8,
                      m: 2,
                      background: "#58CC02",
                    }}
                  >
                    {loading ? "Submitting" : "Create"}
                  </CustomButton>
                </Box>
                {submitted && (
                  <p style={{ color: "green", textAlign: "center" }}>
                    User created successfully
                  </p>
                )}
                {errorMsg ? (
                  <h3 style={{ color: "red", textAlign: "center" }}>
                    Failed to create User
                  </h3>
                ) : null}
              </Box>
            </Box>
            <CustomTitle mt={3}>Bulk Creation of Users</CustomTitle>
            <Box
              sx={{
                alignItems: "center",
                justifyContent: "center",
                border: 1,
                borderRadius: 1,
                p: 3,
                mb: 4,
              }}
            >
              <CustomText sx={{ mt: 4 }}>
                Upload Csv File for Multiple Users
              </CustomText>
              {/* Download <a href="#">Template</a> */}
              <Box
                sx={{
                  border: 1,
                  borderStyle: "dashed",
                  borderRadius: 3,
                  p: 1,

                  textAlign: "center",
                }}
              >
                <Grid container sx={{ py: 2, px: 2 }}>
                  <Grid item xs={8} sx={{ py: 2 }}>
                    {requestFile && (
                      <CustomButton
                        sx={{
                          p: 1,
                          "&:hover": {
                            backgroundColor: "#fbf9f9",
                          },
                        }}
                      >
                        {" "}
                        <DeleteOutlineIcon
                          onClick={() => setRequestFile()}
                          sx={{ color: "#58CC02" }}
                        />
                      </CustomButton>
                    )}

                    <CustomButton
                      component="label"
                      sx={{
                        p: 2,
                        font: "16px bloggerSans",
                        background: "#58CC02",
                      }}
                    >
                      <input
                        type="file"
                        accept=".csv"
                        id={"requestLogFile"}
                        onChange={(e) => changeHandler(e)}
                        hidden
                      />
                      {requestFile ? `${requestFile.name}` : "Add File"}
                    </CustomButton>
                  </Grid>
                  <Grid item xs={4} sx={{ py: 2 }}>
                    <CustomButton1
                      sx={{
                        width: "50%",
                        py: "10px",
                        borderRadius: "0 5px 5px 0",
                      }}
                      onClick={handleFileSubmit}
                      disabled={!requestFile || fileUploading}
                    >
                      {fileUploading ? "Uploading..." : "Upload"}
                    </CustomButton1>
                  </Grid>

                  {fileUploadSuccess && (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        color: "green",
                      }}
                    >
                      <CustomTitle>File Uploaded Successfully</CustomTitle>
                    </Grid>
                  )}
                  {fileUploadFail && (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        color: "red",
                      }}
                    >
                      <CustomTitle> Upload Failed</CustomTitle>
                    </Grid>
                  )}
                  {invalidRows.length > 0 && (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        color: "red",
                      }}
                    >
                      <CustomText sx={{ fontSize: "14px" }}>
                        You have {invalidRows.length} invalid rows
                      </CustomText>
                      {invalidRows.length < 21 &&
                        invalidRows.map((item, index) => (
                          <CustomText
                            key={index}
                            sx={{
                              display: "inline",
                              fontSize: "13px",
                            }}
                          >
                            {(index ? "," : "") + item}
                          </CustomText>
                        ))}
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Box>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default CreateUsers;
